import {
  Box,
  Divider,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAllStores } from "../../redux/slices/adminStoreSlice";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

import { Pie } from "react-chartjs-2";
import { getAllProducts } from "../../redux/slices/adminProductsSlice";
import { getMe } from "../../redux/slices/userSlice";
import { getAllReceiptsQuery } from "../../redux/slices/receiptsSlice";
import { extractSoldItems, processDataForChart } from "../../utils/utils";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRange } from "react-date-range";

ChartJS.register(ArcElement, Tooltip, Legend);

const AdminReports = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [store, setStore] = useState();
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);
  const [chartData, setChartData] = useState();

  const handleOnStoreChange = (event) => {
    setStore(event.target.value);
  };

  const allDefinedStores = useSelector(
    (state) => state.adminStores.allDefinedStores
  );
  const allDefinedProducts = useSelector(
    (state) => state.adminProducts.allDefinedProducts
  );
  const allReceipts = useSelector((state) => state.receipts.allReceipts);

  useEffect(() => {
    dispatch(getMe()).then((response) => {
      dispatch(getAllStores());
      dispatch(getAllProducts());
      dispatch(getAllReceiptsQuery());
    });
  }, [dispatch]);
  useEffect(() => {
    if ((allDefinedProducts && allReceipts, store)) {
      const data = processDataForChart(
        allDefinedProducts,
        allReceipts,
        store,
        "Prodato u lokalu za period",
        dateRange
      );
      setChartData(data);
    }
  }, [allDefinedProducts, allReceipts, store, dateRange]);

  function storeSelect() {
    return (
      <Grid display="flex" alignItems="center">
        <Stack marginTop="12px" minWidth="200px">
          <Typography component="div" marginBottom="16px">
            {t("processReceiptModal.chooseLocation")}
          </Typography>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={store}
            onChange={handleOnStoreChange}
          >
            {allDefinedStores?.map((store) => {
              return <MenuItem value={store}>{store.name}</MenuItem>;
            })}
          </Select>
        </Stack>
      </Grid>
    );
  }
  function dateSelect() {
    return (
      <DateRange
        editableDateInputs={true}
        onChange={(item) => setDateRange([item.selection])}
        moveRangeOnFirstSelection={false}
        ranges={dateRange}
      />
    );
  }
  function getAllSoldItems() {
    const data = extractSoldItems(allReceipts, allDefinedProducts);
    let totalQty = 0;
    return (
      <Stack display="flex" direction="column" marginTop="24px">
        {data?.map((item) => {
          totalQty += item.qty;
          return (
            <Stack display="flex" direction="column">
              <Stack
                display="flex"
                direction="row"
                justifyContent="space-between"
                padding="8px 4px"
              >
                <Typography>{item.itemName}</Typography>
                <Typography>{item.qty}</Typography>
              </Stack>
              <Divider />
            </Stack>
          );
        })}
        <Grid marginTop={2}>
          <Typography>Total: {totalQty}</Typography>
        </Grid>
      </Stack>
    );
  }
  return (
    <Box padding="24px">
      <Stack
        display="flex"
        direction="row"
        marginTop="24px"
        alignItems="start"
        justifyContent="space-between"
      >
        <Stack display="flex" direction="row" alignItems="start">
          <Stack display="flex" direction="column">
            <Stack direction="row">{storeSelect()}</Stack>
            <Stack marginTop="32px" direction="column">
              <Typography component="div" marginBottom="16px">
                {t("processReceiptModal.chooseDatePeriod")}
              </Typography>
              {dateSelect()}
            </Stack>
          </Stack>
          <Stack width={600} marginLeft="100px">
            {chartData && chartData.labels.length > 0 ? (
              <Pie data={chartData} />
            ) : (
              <Stack
                display="flex"
                direction="column"
                justifyContent="center"
                alignItems="center"
                height="400px"
              >
                <Typography color="error" variant="h5">
                  {t("processReceiptModal.noData")}
                </Typography>
              </Stack>
            )}
          </Stack>
        </Stack>
        <Stack display="flex" direction="column">
          <Typography variant="h5">
            {t("processReceiptModal.totalItemsSold")}
          </Typography>
          {getAllSoldItems()}
        </Stack>
      </Stack>
    </Box>
  );
};
export default AdminReports;
